<div class="header">
  <div class="header-content">
    <button mat-icon-button (click)="toggleDrawerState()" class="icon-white-bg">
      @if(this.drawerService.state()) {
        <mat-icon>menu_open</mat-icon>
      }
      @else{
        <mat-icon>menu</mat-icon>
      }
    </button>
    <img routerLink="/dashboard" class="logo-size" src="/img/logo.svg" alt="logo" />
  </div>
  <div class="center-user-content">
    <mat-icon class="logout-button" (click)="logout()">logout</mat-icon>
  </div>
</div>
